import MuiListItem, { ListItemProps as MuiListItemProps } from '@mui/material/ListItem';

export type ListItemProps = MuiListItemProps;

export const ListItem = (props: ListItemProps) => {
  return <MuiListItem {...props} />;
};
